import React from 'react';
import { Hero } from '../components/Hero';
import { Lead } from '../components/Lead';
import { PainPoints } from '../components/PainPoints';
import { OldSolutions } from '../components/OldSolutions';
import { Mechanism } from '../components/Mechanism';
import { Outcome } from '../components/Outcome';
import { Deliverables } from '../components/Deliverables';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0a0f] text-[#f5f5f5] selection:bg-[#ff2d7a] selection:text-white overflow-x-hidden" data-id="element-151">
      {/* Meta Pixel */}
      <MetaPixel data-id="element-152" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-153">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=780668617738771&ev=PageView&noscript=1" alt="" data-id="element-154" />
      </noscript>

      <Hero data-id="element-155" />
      <Lead data-id="element-156" />
      <PainPoints data-id="element-157" />
      <OldSolutions data-id="element-158" />
      <Mechanism data-id="element-159" />
      <Outcome data-id="element-160" />
      <Deliverables data-id="element-161" />
      <FAQ data-id="element-162" />
      <FinalCTA data-id="element-163" />
      <Footer data-id="element-164" />
    </main>;
}